import InfoIcon from '@mui/icons-material/Info';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { orange } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import { MaterialDesignContent } from 'notistack';

const SuccessIcon = () => {
	const circle = orange[50];
	const check = orange[500];

	return (
		<SvgIcon viewBox='0 0 24 24'>
			<circle cx='12' cy='12' r='10' fill={circle} />
			<path d='M10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z' fill={check} />
		</SvgIcon>
	);
};

export const StyledSnackbarContent = styled(MaterialDesignContent)(
	({ theme }) => ({
		'&.notistack-MuiContent': {
			backgroundColor: theme.palette.background.paper,
			color: theme.palette.text.primary,
			border: `1px solid ${theme.palette.divider}`,
			borderRadius: '8px',
			padding: '14px 20px',
			fontSize: '16px',
			lineHeight: 1.5,
			boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
			'& #notistack-snackbar': {
				padding: 0
			},
			'& svg': {
				marginRight: '12px',
				fontSize: '24px'
			}
		},
		'&.notistack-MuiContent-error svg, &.notistack-MuiContent-warning svg': {
			color: theme.palette.error.main
		},
		'&.notistack-MuiContent-info svg, &.notistack-MuiContent-default svg': {
			color: theme.palette.info.main
		}
	})
);

export const snackbarIconVariant = {
	success: <SuccessIcon />,
	error: <WarningRoundedIcon />,
	warning: <WarningRoundedIcon />,
	info: <InfoIcon />
};
